import React, { useEffect, useState } from "react";
import Image from "../Image/Image";
import classes from "./PrimaryButtonLoader.module.scss";
import { getOracleCTAClick } from "../../../shared/AdobeUtility";
import { useSelector } from "react-redux";
const PrimaryButtonLoader = (props) => {

  const [isActive, setIsActive] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoad, setIsLoad] = useState(true);
  //
  const userDetail = useSelector((state) => state.User.UserDetail);
  const currentAppState = useSelector((state) => state.AppState);

  const { appState } = props;
  useEffect(() => {
    setTimeout(() => {
      setIsLoad(false);
    }, 1800);
  });
  useEffect(() => {
    if (appState.loading) {
      setIsActive(true);
      setTimeout(() => {
        !appState.isSubmitedSuccess && setIsLoader(true);
        //setIsLoader(true);
      }, 125);
    }
    if (appState.isSubmitedSuccess) {
      setIsActive(false);
      setIsLoader(false);
      setIsSuccess(true);
    }
    if (!appState.loading && !appState.isSubmitedSuccess) {
      setIsActive(false);
      setIsLoader(false);
      setIsSuccess(false);
    }
  }, [appState]);

  // Clean the isActive state in the unmount
  useEffect(() => {
    return () => {
      setIsActive(false);
    };
  }, []);
  return (
    <div className={classes.ButtonCont}>
      <button
        id="primaryButtonLoaderId"
        className={`
                ${isLoad ? classes.onLoad : ""} 
                ${isActive && isLoader ? classes.active + " " + classes.loader : ""} 
                ${isSuccess ? classes.success : ""} 
                ${props.className} ${props.disabled && classes.DisableBtn}
            `}
        //onClick={(e) => props.handleClick(e)}

        onClick={(e) => {
          let from_page = "SD2";
          if (currentAppState.screenName === "errorScreen" && currentAppState.currentAction === "SavePerDetails") {
            from_page = "SD25";
          }
          else if (currentAppState.currentAction === "SavePerDetails") {
            from_page = "SD3";
          }
          else if (currentAppState.screenName === "otpview") {
            from_page = "SD4";
          }
          else if (currentAppState.screenName === "city") {
            from_page = "SD5";
          }
          else if (currentAppState.screenName === "pan") {
            from_page = "SD6";
          }
          else if (currentAppState.screenName === "email") {
            from_page = "SD7";
          }
          else if (currentAppState.screenName === "professional") {
            from_page = "SD8";
          }
          else if (currentAppState.screenName === "officeaddress") {
            from_page = "SD9";
          }
          else if (currentAppState.screenName === "digiConsent") {
            from_page = "SD16";
          }
          else if (currentAppState.screenName === "resiaddress") {
            from_page = "SD10";
          } 
          else if (currentAppState.screenName === "kycDetails") {
            from_page = "SD11";
          }
          else if (currentAppState.screenName === "vkycOptionScreen") {
            from_page = "SD12";
          }
          else if (currentAppState.screenName === "VkycMitc") {
            from_page = "SD24";
          }
          else if (currentAppState.screenName === "applicationConscent" && currentAppState.currentAction !== "fetch_fee") {
            from_page = "SD14";
          }
          else if (currentAppState.screenName === "wip") {
            from_page = "SD17";
          }
          else if (currentAppState.screenName === "personalDetails") {
            from_page = "SD18";
          }
          else if (currentAppState.screenName === "takePhoto") {
            from_page = "SD19";
          }
          else if (currentAppState.screenName === "genderView") {
            from_page = "SD20";
          }
          else if (currentAppState.screenName === "applicationConscent" && currentAppState.currentAction === "fetch_fee") {
            from_page = "SD24";
          }
          else if (currentAppState.screenName === "incomeSurrogate") {
            from_page = "SD22";
          }
          else if (currentAppState.screenName === "conditionalMITC" && currentAppState.currentAction === "fetch_fee") {
            from_page = "SD24";
          }
          getOracleCTAClick('', currentAppState, from_page, userDetail?.shortCode);
          if (props.handleClick) props.handleClick(e);
        }}

        disabled={(isLoader && isActive) || isSuccess || props.disabled}
        data-testid={props.dataTestid}
      >
        {!isActive && !isSuccess && (
          <span className={classes.Content}>{props.label}</span>
        )}
        {props.filename && !isActive && !isSuccess && (
          <Image
            className={classes.Image}
            filename={props.filename ? props.filename : "Path426"}
            renditions={props.renditions}
            ext={props.ext ? props.ext : "png"}
          />
        )}

        {!props.filename && !isActive && !isSuccess && (
          <Image
            className={classes.Image}
            filename={
              props.disabled ? "arrow_forward_black-2" : "arrow_forward_black-1"
            }
            renditions={["2x"]}
            ext={"png"}
          />
        )}

        {isSuccess && (
          <Image
            className={`${classes.ImageFinish} img-finish`}
            filename="Path -21"
            renditions={props.renditions}
            ext="png"
          />
        )}
      </button>
    </div>
  );
};

export default PrimaryButtonLoader;
